<template>
    <div id="login-page">
        <div class="card" id="card-login">
            <img src="../assets/media/apps/sapx-logo.svg" class="img-logo"/>
            <div class="form-login">
                <div class="input-group mb-5">
                    <span class="input-group-text"><font-awesome-icon icon="fa-solid fa-user" /></span>
                    <input type="text" v-model="username" placeholder="Username" class="form-control" style="font-size:1.5em;" autocomplete="off" aria-label="Username" aria-describedby="basic-addon1"/>
                </div>
                <div class="input-group mb-5">
                    <span class="input-group-text"><font-awesome-icon icon="fa-solid fa-lock" /></span>
                    <input type="password" id="password" v-model="password" placeholder="Password" class="form-control" style="font-size:1.5em;" aria-label="Username" aria-describedby="basic-addon1"/>
                    <span class="input-group-text" @click="passwordVisibility()">
                        <font-awesome-icon icon="fa-solid fa-eye" v-if="passwordVisibilityAction == false" />
                        <font-awesome-icon icon="fa-solid fa-eye-slash" v-else />
                    </span>
                </div>
                <button :disabled="disabledBtnLogin" class="btn btn-primary" style="width:100%;font-size:1.8em;" @click="login()">{{ txtLogin }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import { toast } from 'vue3-toastify';
import api from '../api'
import {MD5} from 'crypto-js'

export default {
    name : "LoginPage",
    data(){
        return {
            passwordVisibilityAction : false,
            username: "",
            password: "",
            txtLogin: "Login",
            disabledBtnLogin : false
        }
    },
    methods: {
        passwordVisibility(){
            let txtPassword = document.getElementById("password")
            if (txtPassword.type === "password") {
                txtPassword.type = "text"
                this.passwordVisibilityAction = true
            } else {
                txtPassword.type = "password"
                this.passwordVisibilityAction = false
            }
        },
        login(){
            let username = this.username
            let password = MD5(this.password).toString()
            this.txtLogin = "Loading...."
            this.disabledBtnLogin = true;
            if(username =="" || password == ""){
                toast("Isi Username Dan Password", {
                    autoClose: 3000,
                    theme: "light",
                    type: "error",
                    pauseOnHover: false,
                    position: "top-right",
                    multiple: false,
                    style: {
                        fontSize: "1.3em",
                    }
                })
                this.txtLogin = "Login"
                this.disabledBtnLogin = false
            }else{
               
                api.get("login_sapx",{
                    params :{
                        "username": username,
                        "password": password
                    }
                }).then((response) => {
                    if(response.data.alert == 'success'){
                        this.txtLogin = "Login"
                        localStorage.setItem('token', response.data.data.token)
                        localStorage.setItem('name', response.data.data.name)
                        localStorage.setItem('branch_code', response.data.data.branch_code)
                        localStorage.setItem('virtual_account_no', response.data.data.virtual_account_no)
                        localStorage.setItem('virtual_account_name', response.data.data.virtual_account_name)
                        this.$router.push('/dashboard')
                    }else{
                        toast(response.data.msg, {
                            autoClose: 3000,
                            theme: "light",
                            type: "error",
                            pauseOnHover: false,
                            position: "top-right",
                            multiple: false,
                            style: {
                                fontSize: "1.3em",
                            }
                        })
                        this.txtLogin = "Login"
                        this.disabledBtnLogin = false
                    }
                }).catch(function (error) {
                    // this.txtLogin = "Login"
                    // this.disabledBtnLogin = false
                    toast(error.message, {
                        autoClose: 3000,
                        theme: "light",
                        type: "error",
                        pauseOnHover: false,
                        position: "top-right",
                        multiple: false,
                        style: {
                            fontSize: "1.3em",
                        }
                    })
                })
            }
        }
    }
}
</script>
<style scoped>
#login-page{
    background-color:#f36f21;
    height:100vh;
}
#card-login{
    width:80%;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
}
.img-logo{
    width:50%;
    margin:auto;
}
.form-login{
    padding:30px;
}
</style>
